import { useState } from "react";
import { api } from "@/lib/api";

export default function LoanReturnHistoryPanel() {
    const [busy, setBusy] = useState(false);
    const [preview, setPreview] = useState(null);
    const [done, setDone] = useState(null);
    const [err, setErr] = useState(null);

    const run = async (fn) => {
        setBusy(true); setErr(null);
        try { await fn(); } catch (e) { setErr(e.response?.data?.detail || e.message); } finally { setBusy(false); }
    };
    const load = () => run(async () => setPreview((await api.get("/admin/loan-returns-history/preview")).data));
    const apply = () => run(async () => {
        if (!window.confirm(`Aggiungere le righe di rientro allo storico di ${preview.count} giocatori?`)) return;
        setDone((await api.post("/admin/loan-returns-history/apply")).data);
        setPreview((await api.get("/admin/loan-returns-history/preview")).data);
    });

    return (
        <div className="op-card p-5 mb-6 border-l-2" style={{ borderLeftColor: "rgb(var(--tc-7ce38b))" }} data-testid="loan-return-history-panel">
            <div className="flex items-end justify-between flex-wrap gap-3">
                <div className="flex-1 min-w-[200px]">
                    <div className="op-label text-t7ce38b">// STORICO · RIENTRI DAL PRESTITO</div>
                    <p className="op-mono text-[11px] text-t8f95a3 mt-2 max-w-2xl leading-relaxed">
                        Aggiunge allo storico carriera i rientri dal prestito già avvenuti (inizio stagione e richiami).
                        Solo informativo: non cambia etichette, soldi o contratti.
                    </p>
                </div>
                <button onClick={load} disabled={busy} data-testid="loan-return-history-preview"
                    className="op-btn px-4 py-2 border border-t7ce38b/40 text-t7ce38b disabled:opacity-50">
                    {busy ? "…" : "Mostra elenco"}
                </button>
            </div>
            {preview && (
                <div className="mt-4 pt-3 border-t border-t22252a" data-testid="loan-return-history-result">
                    {preview.count === 0 ? (
                        <div className="op-mono text-[12px] text-t7ce38b">✓ Nessun rientro da aggiungere.</div>
                    ) : (
                        <>
                            <ul className="space-y-1 max-h-72 overflow-y-auto pr-2">
                                {preview.items.map((it) => (
                                    <li key={it.entry_id} className="op-mono text-[12px]" data-testid={`loan-return-item-${it.entry_id}`}>
                                        <span className="text-tffffff">{it.player_name}</span>
                                        {it.rows.map((r, i) => (
                                            <span key={i} className="text-t8f95a3">
                                                {" — "}S{it.season} {r.team} ({r.kind}{r.from ? `, da ${r.from}` : ""})
                                            </span>
                                        ))}
                                    </li>
                                ))}
                            </ul>
                            <button onClick={apply} disabled={busy} data-testid="loan-return-history-apply"
                                className="op-btn mt-3 px-4 py-2 border border-t7ce38b/50 text-t7ce38b disabled:opacity-50">
                                {busy ? "…" : `Aggiungi allo storico (${preview.count})`}
                            </button>
                        </>
                    )}
                    {done && <div className="op-mono text-[12px] text-t7ce38b mt-2" data-testid="loan-return-history-done">✓ Aggiornati {done.updated}.</div>}
                </div>
            )}
            {err && <div className="mt-3 text-xs text-tff3b30" data-testid="loan-return-history-error">{err}</div>}
        </div>
    );
}
